let CamelToKebab = function () {
  return function(input, param){
    if(angular.isDefined(input)){
      return input.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
    }
  }
}
export default CamelToKebab;



// WEBPACK FOOTER //
// ./client/app/common/filters/camelToKebabService/camelToKebab.filter.js